module.exports = __webpack_public_path__ + "img/passive_timer.d271ec2f.svg";